export const formatNumber = (number) => {
    try {
        //remove all commas
        let numberReplaced = number.toString().replace(/,/g, '');
        //format number 1000000 to 100,000,000 with 2 decimal points
        return parseFloat(+numberReplaced).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }catch{
        return "0.00";
    }
  };
    